export default {
  default: {
    title: 'No Users',
    paragraph: 'Try adjusting your filters to return more results.',
  },
}
